import React from 'react'
import { useSelector } from 'react-redux'

import { User, fullName } from 'packages/grimoire'

import { getCurrentCoveragePartner } from 'app/fieldapp/store/users/selectors'
import { getCoveragePartnerOptions } from 'app/fieldapp/store/users/selectors/getCoveragePartnerOptions'

import { useCrossCoverageDrawerTranslations } from '../../../useCrossCoverageDrawerTranslations'
import {
  CrossCoverageFormAction,
  CrossCoverageFormState,
} from '../../state/CrossCoverageForm.reducer'
import { AssigneeSelectionForm } from './AssigneeSelectionForm'

type AssigneeSelectionFormContainerProps = {
  formDispatch: React.Dispatch<CrossCoverageFormAction>
  formState: CrossCoverageFormState
}

export const AssigneeSelectionFormContainer: React.FC<AssigneeSelectionFormContainerProps> =
  React.memo(({ formDispatch, formState }) => {
    const { isAssigneeBeingOverridden, selectedAssignee } = formState
    const strings = useCrossCoverageDrawerTranslations()

    const currentCoveragePartner = useSelector(getCurrentCoveragePartner)
    const assigneeSelectorOptions = useSelector(getCoveragePartnerOptions)

    const handleAssigneeChange = (user: User) => {
      formDispatch({
        payload: user,
        type: 'setSelectedAssignee',
      })
    }

    const handleAssigneeOverrideClick = () => {
      formDispatch({
        payload: true,
        type: 'setIsAssigneeBeingOverridden',
      })
    }

    const overrideSelectButtonTextValue = !!currentCoveragePartner
      ? fullName(currentCoveragePartner)
      : strings.noCoveragePartnerSelected

    return (
      <AssigneeSelectionForm
        assigneeSelectorOptions={assigneeSelectorOptions}
        isAssigneeBeingOverridden={isAssigneeBeingOverridden}
        onAssigneeChange={handleAssigneeChange}
        overrideSelectButtonTextValue={overrideSelectButtonTextValue}
        onAssigneeOverrideClick={handleAssigneeOverrideClick}
        selectedAssignee={selectedAssignee}
      />
    )
  })
